import Vue from "vue";

Vue.directive("input-min-max", {
  bind: function(el: any, binding: any, vnode: any) {
    el.addEventListener("keyup", (event: any) =>
      changeInput(el, event, binding, vnode)
    );
  },
  unbind: function(el: any, binding: any, vnode: any) {
    el.removeEventListener("keyup", (event: any) =>
      changeInput(el, event, binding, vnode)
    );
  }
});

function changeInput(el: any, event: any, binding: any, vnode: any) {
  el.value =
    Number(event.target.value) < binding.value.min || event.target.value === ""
      ? binding.value.min
      : el.value;

  el.value =
    Number(event.target.value) > binding.value.max
      ? binding.value.max
      : el.value;
  vnode.elm.dispatchEvent(new CustomEvent("input"));
}
